module.exports = __webpack_public_path__ + "static/media/app_development.b2a08820.svg";